import { FormGroup, Icon } from "@blueprintjs/core";
import { MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { TipiStore } from "../../stores/legislacao/TipiStore";
import { AppStore } from "../../stores/AppStore";
import { Pager } from "../utils/Pager";

const InputMask = require("react-input-mask");
var debounce = require('lodash.debounce');

interface TipiProps {
}

interface TipiState {
}

@observer
export class TipiPage extends React.Component<TipiProps, TipiState> {

  obs = observable({
    page: 1 as number,
    fetchOptions: {} as any
  })

  constructor(props) {
    super(props);
    this.state = { handlePageChange: props.handlePageChange };

    this.obs.fetchOptions = debounce(this.handleBusca.bind(this), 800);

  }

  async componentDidMount() {

    AppStore.setTitle("Tabela Tipi");

    await TipiStore.load(1);

  }

  handlePageChange = async (page: number) => {
    TipiStore.load(page);
    this.obs.page = page;
  };

  handleBusca = async (filter) => {

    const numbers = filter.match(/\d+/g);

    if (numbers != null) {

      await TipiStore.busca(numbers.join(''), this.obs.page);

    } else {

      await TipiStore.load(this.obs.page);

    }

  };

  render() {

    const formattValidade = (cell, row) => {

      return (
        <>
          {
            row.data_inicio  ?
            <span>{moment(row.data_inicio).format("DD/MM/YYYY")}</span>
              :
            <span>Sempre</span>
          }
          <Icon icon="arrow-right" style={{ margin: "0 5px" }} />
          {
            row.data_fim ?
              <span>{moment(row.data_fim).format("DD/MM/YYYY")}</span>
              :
              <span>Sempre</span>
          }
        </>
      )
    };

    return (
      <>
        <MDBRow xl="12" lg="12" md="12" sm="12">
          <MDBCol xl="2" lg="2" md="2" sm="2">
            <FormGroup label="NCM">
              <InputMask
                mask="9999.99.99"
                className="form-control"
                onChange={(e) => this.obs.fetchOptions(e.target.value)}
              />
            </FormGroup>
          </MDBCol>

        </MDBRow>

        <div data-tut="table">
          <BootstrapTable
            className="TableDefault"
            ref="table"
            data={TipiStore.obs.tipis}
          >
            <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">
              #
            </TableHeaderColumn>
            <TableHeaderColumn dataField="ncm" width="10%">
              NCM
            </TableHeaderColumn>
            <TableHeaderColumn dataFormat={formattValidade} width="10%">
              Validade
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="descricao"
              width="10%"
            >
              Descrição
            </TableHeaderColumn>
          </BootstrapTable>
        </div>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.page}
            totalCount={TipiStore.obs.total}
            pageSize={15}
            onPageChange={this.handlePageChange}
          />
        </div>
      </>
    );
  }
}
